<template>
  <b-modal
    id="language-change-modal"
    ref="language-change-modal"
    size="lg"
    hide-header-close
    no-close-on-esc
    no-close-on-backdrop
    centered
  >
    <template v-slot:modal-header>
      <h5 class="modal-title mb-0">
        Change Articles Language
      </h5>
    </template>
    <div>
      <p class="">
        This action changes the language assigned to all selected articles for matching purposes only. Changing the article language will not translate it.
      </p>
      <div>
        <p class="mb-1 font-weight-bold">
          Select new language
        </p>
        <b-form-select
          :options="languages"
          :value="selectedLanguageId"
          @change="selectLanguage($event)"
          value-field="id"
          text-field="name"
          data-test="language-select"
        >
          <template v-slot:first>
            <b-form-select-option
              :value="null"
              class="d-none"
              disabled
            >
              Select new language
            </b-form-select-option>
          </template>
        </b-form-select>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button
        variant="tertiary"
        @click="closeModal()"
        data-test="cancel-language-change-btn"
      >
        Cancel
      </b-button>
      <b-button
        variant="primary"
        @click="setNewSelectedLanguage(selectedLanguageId)"
        :disabled="!selectedLanguageId"
        data-test="select-language-change-btn"
      >
        Next
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'LanguageChangeModal',
  data() {
    return {
      selectedLanguageId: null,
    };
  },
  computed: {
    ...mapState('content', [
      'languages',
    ]),
  },
  methods: {
    selectLanguage(languageId) {
      this.selectedLanguageId = languageId;
    },
    setNewSelectedLanguage(languageId) {
      if (!languageId) return;
      this.$emit('setNewSelectedLanguage', languageId);
      this.closeModal();
    },
    closeModal() {
      this.selectedLanguageId = null;
      this.$root.$emit('bv::hide::modal', 'language-change-modal');
    },
  },
};
</script>
